import PAYMENT_LIST from "../graphql/paymentList.gql";
import { apolloClient } from "./apollo";
/**
 * This is only mock api
 *
 */
export function getPaymentList() {
    return apolloClient.mutate({
        mutation: PAYMENT_LIST
    })
}
